import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useInView } from 'react-intersection-observer';
import BlogCardListing from '@/features/blog/components/blog-card-listing/blog-card-listing';
import ListingCard from '@/features/listing/components/listing-card/listing-card';
import { type BlogPostTrigger } from '@/features/listing/components/listings-section/listings-list/listings-infinity-scroll';
import { PaginationNames } from '@/features/listing/types/listing-filters-types';
import { type ListingCardView, type ListingWithUser } from '@/features/listing/types/listing-types';
import styles from './listings-list.module.scss';
interface ListingsListInfinityProps {
  listingsList: (ListingWithUser | BlogPostTrigger)[];
  listingView: ListingCardView;
  pageNumber: number;
}
const updatePageNumber = (pageNumber: number, mode: 'push' | 'replace' = 'push') => {
  const searchParams = new URLSearchParams(globalThis.location.search);
  searchParams.set(PaginationNames.PageNumber, String(pageNumber));
  const url = `${globalThis.location.pathname}?${searchParams.toString()}`;
  if (mode === 'push') {
    globalThis.history.pushState({}, '', url);
  } else {
    globalThis.history.replaceState({}, '', url);
  }
};
export default function ListingsListInfinity(props) {
  const $ = _c(29);
  const {
    listingView,
    listingsList,
    pageNumber
  } = props;
  let t0;
  if ($[0] !== pageNumber) {
    t0 = inView => {
      if (inView) {
        updatePageNumber(pageNumber, "replace");
      }
    };
    $[0] = pageNumber;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [0.5, 1];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = {
      onChange: t0,
      threshold: t1
    };
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [firstRef] = useInView(t2);
  let t3;
  if ($[5] !== pageNumber) {
    t3 = inView_0 => {
      if (inView_0) {
        updatePageNumber(pageNumber, "replace");
      }
    };
    $[5] = pageNumber;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0.5, 1];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = {
      onChange: t3,
      threshold: t4
    };
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [lastRef] = useInView(t5);
  const lastIndex = listingsList.length - 1;
  const t6 = styles[`listingsList__${listingView}`];
  let t7;
  if ($[10] !== t6) {
    t7 = cx(styles.listingsList, t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== firstRef || $[13] !== lastIndex || $[14] !== lastRef || $[15] !== listingView || $[16] !== listingsList || $[17] !== pageNumber) {
    let t9;
    if ($[19] !== firstRef || $[20] !== lastIndex || $[21] !== lastRef || $[22] !== listingView || $[23] !== pageNumber) {
      t9 = (card, index) => {
        if ("type" in card) {
          return <div key="blog-post" className={styles.listingsList_listingCard}><BlogCardListing /></div>;
        }
        return <div ref={index === 0 ? firstRef : index === lastIndex ? lastRef : null} key={card.id} className={styles.listingsList_listingCard} onPointerDown={() => {
          updatePageNumber(pageNumber);
        }}><ListingCard listing={card} listingViewVariant={listingView} messageSrc="search-grid" /></div>;
      };
      $[19] = firstRef;
      $[20] = lastIndex;
      $[21] = lastRef;
      $[22] = listingView;
      $[23] = pageNumber;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    t8 = listingsList.map(t9);
    $[12] = firstRef;
    $[13] = lastIndex;
    $[14] = lastRef;
    $[15] = listingView;
    $[16] = listingsList;
    $[17] = pageNumber;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[25] !== pageNumber || $[26] !== t7 || $[27] !== t8) {
    t9 = <div className={t7} data-page={pageNumber}>{t8}</div>;
    $[25] = pageNumber;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}